export default "__VITE_ASSET__B_AwMs2i__"